import { Component, HostListener, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { CommonDataService } from '../../../../common/services/common-data.service';
import { LoginService } from '../../../../common/services/Login.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { GraphqlService } from '../../../../common/services/graphql.service';
import { constObj } from '../../../../common/Constants/constants';
import { HttpcallService } from '../../../../common/services/httpcall.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'app-paragraph-action-menu',
  templateUrl: './paragraph-action-menu.component.html',
  styleUrls: ['./paragraph-action-menu.component.css']
})
export class ParagraphActionMenuComponent implements OnInit, OnDestroy, OnChanges {
  articleId: string = "";
  @Input() checked: boolean;
  @Input() compname: string = "";
  showSourcesToggle: boolean = false;
  isAcademic: boolean = false;
  @Input() UserInfo: any;

  private destroy$: Subject<void> = new Subject<void>();
  constructor(
    public commonDataService: CommonDataService, private loginService: LoginService,
    private httpCallService: HttpcallService,
    private graphQlService: GraphqlService,
  ) {
  }

  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;

  @HostListener('click', ['$event']) click(event:any) {
    const path : any = event.composedPath() as Array<any>;
    const matFormField = path.find(p => p.tagName && p.tagName.toLowerCase() === 'button');
  
    if (matFormField) {
      var matMenuHeight;
      var buttonPosition=matFormField.getBoundingClientRect();
      var cdk_pane=Array.from(document.getElementsByClassName('cdk-overlay-pane') as HTMLCollectionOf<HTMLElement>);
      cdk_pane.forEach(x=>{
        matMenuHeight=x.clientHeight;
          if(buttonPosition.top > matMenuHeight){
            x.style.top = buttonPosition.top - matMenuHeight + 'px' ;
            x.style.bottom ='unset';
          }
          else{
            x.style.top = buttonPosition.top + 34 + 'px';
            // x.style.bottom = buttonPosition.bottom +'px';
          }
          x.style.right='1rem';
        x.style.left = buttonPosition.left - 91 + 'px';
      })
    }
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes.menuListItems != undefined) {
      if (this.menuList.length > 0) {
        this.getBookmarkStatus();
      }
    }
    if (changes.annotationCountString != undefined) {
      this.annotationCount = parseInt((this.annotationCountString == undefined || this.annotationCountString == null) ? "0" : this.annotationCountString);
    }
    if (changes.bookmarkCountString != undefined) {
      this.bookmarkCount = parseInt((this.bookmarkCountString == undefined || this.bookmarkCountString == null) ? "0" : this.bookmarkCountString);
      if (this.menuList.length > 0) {
        this.getBookmarkStatus();
      }
    }
  }


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.articleId = this.paraNum == undefined ? this.paraNum : this.paraNum.replace(/ /g, "_");
    this.checkUserType();
    this.annotationCount = parseInt((this.annotationCountString == undefined || this.annotationCountString == null) ? "0" : this.annotationCountString);
    this.bookmarkCount = parseInt((this.bookmarkCountString == undefined || this.bookmarkCountString == null) ? "0" : this.bookmarkCountString);
    this.getBookmarkStatus();
    this.commonDataService.addAnnotationParagraphId.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data != "") {
        if (this.paragraphId == data) {
          this.annotationCount++;
          this.commonDataService.addAnnotationParagraphId.next("");
        }
      }
    })
    this.commonDataService.deleteAnnotationParagraphId.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data != "") {
        if (this.paragraphId == data) {
          this.annotationCount--;
          this.commonDataService.deleteAnnotationParagraphId.next("");
        }
      }
    })
    this.commonDataService.addBookmarkParagraphId.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data != "") {
        if (this.paragraphId == data) {
          if (this.bookmarkCount == 0) {
            this.bookmarkCount++;
          }
          this.commonDataService.addBookmarkParagraphId.next("");

          this.getBookmarkStatus();
        }
      }
    })
    this.commonDataService.deleteBookmarkParagraphId.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data != "") {
        if (this.paragraphId == data) {
          this.bookmarkCount--;
          this.getBookmarkStatus();
          this.commonDataService.deleteBookmarkParagraphId.next("");

        }
      }
    })

    this.commonDataService.annotationWithinContent.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data == this.paragraphId) {
        this.annotationContentBool = true;
      }
    });
    this.commonDataService.printToggleOff.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data == "printToggleOff") {
        this.printqueueAdd = false;
        this.menuList.value = false;
      }
    });
    this.commonDataService.displayAllSources.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data != null) {
        let toggleVal = data.toggleValue == 'true' ? true : false;
        let event: MatSlideToggleChange = { source: null, checked: toggleVal };
        var item = this.menuList.filter(a => a.value == 'showSources')[0];
        this.toggle(event, item);
      }
    });
  }

  //ngAfterViewInit(): void {
  //  let printQueueData = JSON.parse(localStorage.getItem("SetPrintQueueSession"));
  //  if (printQueueData) {
  //    if (printQueueData != null && printQueueData.printQueueAddedList != null) {
  //      printQueueData.printQueueAddedList.sort().forEach(function (obj, index) {
  //        if (document.getElementById(obj.value) != null) {
  //          document.getElementById(obj.value).style.display = "";
  //        }
  //      });
  //    }
  //  }
  //}

  annotationContentBool: boolean = false;
  emailId: string = "";
  annotationCount: number = 0;
  bookmarkCount: number = 0;
  @Input() paragraphId: string = "";
  @Input() paraArticleId: string = "";
  @Input() annotationCountString: string = "";
  @Input() bookmarkCountString: string = "";
  @Input() menuListItems: string[] = [];
  @Input() printqueueAdd: boolean = false;
  @Input() breadCrumbPath: string = "";
  @Input() parentComponent: string = "";
  @Input() crumbData: any = [];
  @Input() paraNum: string = "";
  @Input() pageNums: string = "";
  @Input() paraTitle: string = "";
  @Input() pageurl: string = "";

  IsBookmark: boolean = false;
  IsBookmarkDelete: boolean;
  clickMenuItem(item) {
    let width = "rightOverLay_small";
    if (item.menuLinkText == 'See XBRL Elements') {
      width = "rightOverlay_large";
      this.commonDataService.XBRLParams.next(this.pageNums);
      this.commonDataService.currentParagraph.next(this.paraNum);
      this.commonDataService.pageUrl.next(this.pageurl);
    }
    if (item.menuLinkText === "Remove Bookmark") {
      this.deleteBookmark()
      return true;
    }
    this.openRightOverlay(item.menuLinkText, width)
  }

  openRightOverlay(str, width) {
    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.rightPanelWidth.next(width);
    this.commonDataService.currentParagraphId.next(this.paragraphId);
    if (this.paraNum != "") { this.commonDataService.currentParagraph.next(this.paraNum); }
    else { this.commonDataService.currentParagraph.next(this.paraTitle); }
    this.commonDataService.emailId.next(this.emailId);
    if (str == "Add Annotation") {
      this.commonDataService.annotationUpdateSource.next("");
    }
    this.commonDataService.breadcrumbPath.next(this.breadCrumbPath);
    if (this.parentComponent == "showAllInOnePage") {
      this.commonDataService.navDataContentPage.next(this.crumbData);
      this.commonDataService.pageUrl.next(this.pageurl);
    }
    this.commonDataService.rightOverlayOption.next(str);
  }
  openAnnotations() {
    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.rightPanelWidth.next("rightOverLay_small");
    this.commonDataService.currentParagraphId.next(this.paragraphId);
    this.commonDataService.currentParagraph.next(this.paraNum);
    this.commonDataService.rightOverlayOption.next("Your Annotations");
    this.commonDataService.breadcrumbPath.next(this.breadCrumbPath);
    if (this.parentComponent == "showAllInOnePage") {
      this.commonDataService.navDataContentPage.next(this.crumbData);
      this.commonDataService.pageUrl.next(this.pageurl);
    }
  }
  getBookmarkStatus() {
    this.IsBookmark = this.bookmarkCount > 0 ? true : false;
    if (this.IsBookmark) {
      this.menuList.filter(x => x.menuLinkText == 'Add Bookmark')[0].menuLinkText = "Remove Bookmark";
    }
    else {
      if (this.menuList.filter(x => x.menuLinkText == 'Remove Bookmark').length > 0) {
        this.menuList.filter(x => x.menuLinkText == 'Remove Bookmark')[0].menuLinkText = "Add Bookmark";
      }
    }
  }
  deleteBookmark() {
    this.commonDataService.showLoader.next(true);
    this.httpCallService.getBookmark(this.paragraphId).subscribe((resp: any) => {
      var bookmarkarray=resp.filter(x=>x.paragraphId==this.paragraphId)[0];
      var bookmark = {
        ID: bookmarkarray.id, TopicId: bookmarkarray.topicId, ParagraphId: bookmarkarray.paragraphId, BookmarkTitle: bookmarkarray.bookmarkTitle, BookMarkBreadCrumb: bookmarkarray.bookMarkBreadCrumb, IsDeleted: true, CreatedOn: bookmarkarray.createdOn, ModifiedOn: bookmarkarray.modifiedOn, ApplicationSource: bookmarkarray.applicationSource,
        BookmarkURL: bookmarkarray.bookmarkURL, NavigationPath: bookmarkarray.navigationPath
      }

      this.httpCallService.addUpdateBookmark(bookmark).toPromise()
        .then(() => {
          this.commonDataService.showLoader.next(false);
          this.commonDataService.deleteBookmarkParagraphId.next(bookmark.ParagraphId);
          let obj = {
            type: 'success',
            displayTime: 5000,
            position: 'bottom',
            message: constObj.bookmarkRemovedMessage
          }
          this.commonDataService.notificationObject.next(obj);

          this.menuList.filter(x => x.menuLinkText == 'Remove Bookmark')[0].menuLinkText = "Add Bookmark";
        })
        .catch(console.log);
    }, err => {
      console.log(err)
      this.commonDataService.showLoader.next(false);
    });
  }

  public toggle(event: MatSlideToggleChange, selectedItem: any) {
   
    if (selectedItem.menuLinkText === 'Show sources') {
      this.showSourcesToggle = event.checked;
      var toggleChnage: string = <string><any>event.checked;
      let sourcesObj = {
        paragraphId: this.paraArticleId,
        toggleValue: toggleChnage
      }
      this.commonDataService.showSources.next(sourcesObj);
    }
    else {
      var toggleChnage1: string = <string><any>event.checked;
      this.articleId = this.paraNum.replace(/ /g, "_");
      let obj = {
        articleId: this.paraArticleId,
        paragraphId: this.paraNum,
        toggleValue: toggleChnage1,
        topic: this.breadCrumbPath?.split('~')[1]?.split(' ')[0],
        subtopic: this.breadCrumbPath?.split('~')[2]?.split(' ')[0],
        section: this.breadCrumbPath?.split('~')?.pop().split(' ')[0]
      }
      if (obj.toggleValue) {
        this.printqueueAdd = true;
      }
      else {
        this.printqueueAdd = false;
      }
      this.commonDataService.printqueueCount.next(obj);
    }
  }

  public toggleByKeyboard(event: MatSlideToggleChange, selectedItem: any) {

    if (selectedItem.menuLinkText === 'Show sources') {
      this.showSourcesToggle = event.checked;
      var toggleChnage: string = <string><any>event.checked;
      let sourcesObj = {
        paragraphId: this.paraArticleId,
        toggleValue: toggleChnage
      }
      this.commonDataService.showSources.next(sourcesObj);
    }
    else {
      if (this.printqueueAdd == true) { this.printqueueAdd = false; }
      else { this.printqueueAdd = true; }
      this.articleId = this.paraNum.replace(/ /g, "_");
      let obj = {
        articleId: this.paraArticleId,
        paragraphId: this.paraNum,
        toggleValue: this.printqueueAdd.toString(),
        topic: this.breadCrumbPath?.split('~')[1]?.split(' ')[0],
        subtopic: this.breadCrumbPath?.split('~')[2]?.split(' ')[0],
        section: this.breadCrumbPath?.split('~')?.pop().split(' ')[0]
      }
      this.commonDataService.printqueueCount.next(obj);
    }
  }

  menuList: any = [];
  checkUserType() {
    this.emailId = this.UserInfo.user.email;
    //if (this.UserInfo.user.roles == "Academic") {
    //    this.isAcademic = true;
    //  }
      this.getMenuListItems();
  }
  getMenuListItems() {
    if (this.UserInfo.user.roles != "Basic") {
      this.menuList = [
        {
          menuLinkText: this.menuListItems[0],
          isDisabled: this.isAcademic,
          value: undefined,
          isToggle: false,
          imgPath: '../../../assets/icons/BookmarkAdd.svg'
        },
        {
          menuLinkText: this.menuListItems[1],
          isDisabled: this.isAcademic,
          value: undefined,
          isToggle: false,
          imgPath: '../../../assets/icons/pencil-alt.svg'
        },
        {
          menuLinkText: this.menuListItems[2],
          isDisabled: this.isAcademic,
          value: undefined,
          isToggle: false,
          imgPath: '../../../assets/icons/Feedback.svg'
        },
        {
          menuLinkText: this.menuListItems[3],
          isDisabled: false,
          value: undefined,
          isToggle: false,
          imgPath: '../../../assets/icons/XBRL-Elements.svg'
        },
        {
          menuLinkText: this.menuListItems[4],
          isDisabled: false,
          value: 'print',
          isToggle: true,
          imgPath: '../../../assets/icons/Print.svg'
        },
        {
          menuLinkText: "Show sources",
          isDisabled: false,
          value: 'showSources',
          isToggle: true,
          imgPath: '../../../assets/icons/ShowSources.svg'
        }
      ];
    } else {
      this.menuList = [
        {
          menuLinkText: this.menuListItems[0],
          isDisabled: this.isAcademic,
          value: undefined,
          isToggle: false,
          imgPath: '../../../assets/icons/Feedback.svg'
        },
        {
          menuLinkText: this.menuListItems[1],
          isDisabled: false,
          value: undefined,
          isToggle: false,
          imgPath: '../../../assets/icons/XBRL-Elements.svg'
        },
        {
          menuLinkText: this.menuListItems[2],
          isDisabled: false,
          value: 'print',
          isToggle: true,
          imgPath: '../../../assets/icons/Print.svg'
        },
        {
          menuLinkText: "Show sources",
          isDisabled: false,
          value: 'showSources',
          isToggle: true,
          imgPath: '../../../assets/icons/ShowSources.svg'
        }
      ];
    }
  }

}
